import React from 'react'
import Report from '../Shared/ReportV2'
import Error404 from '../../../Errors/Error404';

const VALID_TEMPLATES = ["student", "parent", "adult", "overall"];
const ReportWrapperV2 = (props) => {
  const surveyParticipantId = decodeURIComponent(props.match.params.surveyParticipantId);
  const template = decodeURIComponent(props.match.params.template);
  if (VALID_TEMPLATES.includes(template)) {
    const isWellnessCenter = (props.match.path === '/wellness-center/report/:template/:surveyParticipantId')
    // return <Report template="student" id={surveyParticipantId} /> // for now use student report as placeholder
    return <Report isWellnessCenter={isWellnessCenter} templateId={template} id={surveyParticipantId} />
  } else {
    return <Error404 />
  }
}

export default ReportWrapperV2